/**
 * callAPI - Eine generische Funktion für API-Aufrufe
 *
 * @param {Object} options - Konfigurationsobjekt
 * @param {string} options.endpoint - Der Endpoint der API
 * @param {string} [options.method="GET"] - Die HTTP-Methode (GET, POST, PUT, DELETE, etc.)
 * @param {Object} [options.headers={}] - Zusätzliche Header als Objekt
 * @param {Object} [options.params={}] - Query-Parameter als Objekt (werden zur URL hinzugefügt)
 * @param {Object} [options.body=null] - Der Body-Inhalt (wird in JSON umgewandelt)
 * @returns {Promise} - Ein Promise, das die JSON-Antwort oder einen Fehler zurückgibt
 */
function callAPI({
  endpoint,
  method = "GET",
  headers = {},
  params = {},
  body = null,
  errorCallback = () => null
}) {
 
  // Query-Parameter zur URL hinzufügen, falls vorhanden
  const queryString = new URLSearchParams(params).toString();

  // Standardheader: JSON Content-Type
  const defaultHeaders = body instanceof FormData ? {} : {
    "Content-Type": "application/json"
  };

  
  // Kombiniere Standardheader mit zusätzlichen Headern
  const finalHeaders = { ...defaultHeaders, ...headers };

  // Falls ein Body vorhanden ist, konvertiere ihn in einen JSON-String
  const finalBody = body instanceof FormData ? body : body ? JSON.stringify(body) : null;

  // const domain = "http://localhost:8000/api"
  const domain = "https://pikodocs-api.onrender.com/api"
 


  return fetch(domain + endpoint, {
    method: method,
    headers: finalHeaders,
    body: finalBody,
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((errorData) => {
          const error = new Error("API-Fehler");
          error.data = errorData;
          throw error;
        });
      }
      return response.json();
    })
    .catch((error) => {
      console.error("Fehler in callAPI: " + error);
      errorCallback()
      throw error;
    });
}

// Falls du ES6-Module verwendest, kannst du diese Funktion auch exportieren:
// export default callAPI;
